import { AppThunkAction } from "..";
import { KnownAction, RECEIVE_BREACHES_AND_SCAMS_DATA, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    getRssFeedData:
        (userType: string): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (
                state.breachesAndScamsState &&
                state.breachesAndScamsState.breachesAndScamsData != null &&
                state.breachesAndScamsState.breachesAndScamsData.length < 1
            ) {
                dispatch({ type: SHOW_LOADER, isLoading: true });
                services
                    .getRSSFeed("0", userType)
                    .then((data) => {
                        dispatch({ type: RECEIVE_BREACHES_AND_SCAMS_DATA, breachesAndScamsData: data });
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        const temp = error;
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
